import { getColor } from 'common/constants/_colors';
import BoldedValue from 'components/BoldedValue';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import React from 'react';
import styled from 'styled-components';
import ArrowedBox from 'components/ArrowedBox';
import { capitalize } from 'lodash';

const DurationText = styled(Text)`
  .smallUnit {
    font-size: 1.1rem;
    font-weight: normal;
    padding-left: 0.1rem;
  }
`;

const PipelineBar = styled(Flex)`
  height: 0.75rem;
  width: ${({ isV2 }) => (isV2 ? 'calc(100% - 0.8rem)' : '100%')};
  ${({ color }) => `
    background-color: ${getColor(color)};
  `};
  transform: skewX(30deg);
`;

const PipelineItemWrapper = styled(Flex)`
  &:hover {
    background: ${getColor('zircon')};
    border-radius: 4px;
    cursor: pointer;

    .lineBar {
      transform: unset;
      width: 100%;
    }
  }
`;

const StyledFlex = styled(Flex)`
  ${({ isV2 }) =>
    isV2
      ? `  border-top: 2px solid white;
padding-top: 0.5rem;`
      : `  &:hover {
  border-top: 2px solid white;
}`}
`;

const RightTag = styled(ArrowedBox)`
  position: absolute;
  top: 100%;
  right: 0;
  transform: translate(calc(50% + 1rem), 2rem);
`;

const ClickablePipelineItem = ({
  config,
  onClick,
  enableDescription,
  isV2,
  dataCyPrefix
}) => {
  const { color, title, value, description, rightTag } = config;
  const dataCy = `${dataCyPrefix}-${title}-value`;
  const textColor = 'shuttleGray';
  const barColor = color;

  return (
    <PipelineItemWrapper
      onClick={() => onClick(config)}
      direction='column'
      width='100%'
      position='relative'
      overflowY='clip'
      {...(!isV2 && {
        height: '5.82rem',
        mr: 'small',
        ml: 'small'
      })}
    >
      <PipelineBar color={barColor} className='lineBar' isV2={isV2} />
      <StyledFlex
        position='relative'
        width='100%'
        height='100%'
        items='center'
        isV2={isV2}
      >
        <Flex direction='column' width='100%' justify='center' pl='small'>
          {isV2 ? (
            <Flex items='baseline'>
              <DurationText
                size='x-x-large'
                color='shuttleGray'
                weight='300'
                dangerouslySetInnerHTML={{ __html: value }}
                data-cy={dataCy}
              />

              {enableDescription && (
                <Text size='small' color='shuttleGray' pl='0.5rem'>
                  {description}
                </Text>
              )}
            </Flex>
          ) : (
            <BoldedValue
              value={{ text: value, size: 'large', color: 'black' }}
              description={
                enableDescription && {
                  text: description,
                  size: 'small',
                  color: textColor
                }
              }
              dataCy={dataCy}
            />
          )}

          <Text color={textColor} mt='0.3rem' pb='0.5rem'>
            {capitalize(title)}
          </Text>
        </Flex>
        {rightTag && <RightTag text={rightTag} />}
      </StyledFlex>
    </PipelineItemWrapper>
  );
};
export default ClickablePipelineItem;
